import React from 'react';
import { TableCell, Button, useTheme, useMediaQuery, Box } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { Step } from '../../types/Step';
import { getButtonStyles, nameDateStyle } from './StepItemStyles';
import { humanizeTimestamp } from '../../utility/dateUtils';

interface StepRowProps {
  step: Step;
  handleStepToggle: (step: Step, action: 'complete' | 'start') => void;
  editPermitted: boolean;
  taskUuid: string;
}

export const StepItem: React.FC<StepRowProps> = ({ step, handleStepToggle, editPermitted, taskUuid }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const stepsButtonStyles = {
    '& .MuiButton-startIcon': { marginRight: `${isMobile ? '0' : '8px'}` },
    width: { xs: 'fit-content', sm: '100%' },
  };
  return (
    <>
      <TableCell width={'40%'}>{step.name}</TableCell>
      <TableCell width={'30%'}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {taskUuid !== 'new' && (
            <Button
              startIcon={<CheckCircleOutline sx={{ color: `${step.started_at && '#FF9D3D'}` }} />}
              variant="contained"
              onClick={() => handleStepToggle(step, 'start')}
              disabled={!editPermitted}
              style={{
                ...getButtonStyles(!!step.started_at),
                backgroundColor: step.started_at ? '#FFF5EC' : '#fff',
                border: `1px solid ${step.started_at ? '#FF9D3D' : '#E3E3E5'}`,
                display: `${step.completed_at ? 'none' : 'flex'}`,
              }}
              sx={stepsButtonStyles}
            >
              {!isMobile && (step.started_at ? 'In Progress' : 'Mark Start')}
            </Button>
          )}
          <Box sx={nameDateStyle}>
            {step.started_by_name && <Box>{step.started_by_name}</Box>}
            {step.started_at && <Box>{humanizeTimestamp(step.started_at)}</Box>}
          </Box>
        </Box>
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {taskUuid !== 'new' && (
            <Button
              startIcon={<CheckCircleOutline sx={{ color: `${step.completed_at && '#35B23D'}` }} />}
              variant="contained"
              onClick={() => handleStepToggle(step, 'complete')}
              disabled={!editPermitted}
              style={{
                ...getButtonStyles(!!step.completed_at),
                backgroundColor: step.completed_at ? '#E8F5E9' : '#fff',
                border: `1px solid ${step.completed_at ? '#35B23D' : '#E3E3E5'}`,
              }}
              sx={stepsButtonStyles}
            >
              {!isMobile && (step.completed_at ? 'Completed' : 'Mark Completed')}
            </Button>
          )}
          <Box sx={nameDateStyle}>
            {step.completed_by_name && <Box>{step.completed_by_name}</Box>}
            {step.completed_at && <Box>{humanizeTimestamp(step.completed_at)}</Box>}
          </Box>
        </Box>
      </TableCell>
    </>
  );
};
